var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 27.736,
    height: 24,
    viewBox: "0 0 27.736 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.736,
    height: 24,
    fill: "#734bd1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.731,2.216h-11.5v-.01L10.494,0H2.9A2.9,2.9,0,0,0,0,2.9V21a3,3,0,0,0,3,3H24.731a3,3,0,0,0,3-3V5.221a3,3,0,0,0-3-3",
    transform: "translate(0 0)",
    fill: "#734bd1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFolder);
export default __webpack_public_path__ + "static/media/Add_folder.fe382c165684c9b87a04a02b350a40f5.svg";
export { ForwardRef as ReactComponent };